import {observable} from "mobx";
import {BaseModel} from "../../infrastructure/models/base-model";
import {ARGS} from "../../core/bootstrap/args";
import {DeviceUtils} from "../../infrastructure/utils/device-utils";
import {UserSelectionsManager} from "../../core/managers/user-selections.manager";
import type {DatetimeUtils} from "../../infrastructure/utils/datetime-utils";

export class AnalyticsUserDataEventModel extends BaseModel {

  browser_type: String;
  datekey: Number;
  @observable browser_version: String;
  device_platform_type: String;
  device_brand: String;
  device_model: String;
  @observable site_version: String;
  @observable lang_code: String;
  country_code: String;
  city_code: String;
  competitors: Array;
  competitions: Array;
  media_source: String;
  utm_source: String;
  utm_medium: String;
  utm_campaign: String;
  total_teams: Number;
  total_leagues: Number;
  os_lang: String;
  os_type: String;
  os_version: String;
  country_id: Number;
  timezone: String;
  show_wizard_ab_test: Boolean;
  isLiveStreamingLightMode: Boolean;
  website_notifications: String;
  userSelectionsManager: UserSelectionsManager;

  constructor(deviceUtils: DeviceUtils, state, userSelectionsManager: UserSelectionsManager, datetimeUtils: DatetimeUtils) {
    super();

    this.browser_type = deviceUtils.info.browser.name;
    this.browser_version = deviceUtils.info.browser.version;
    this.device_platform_type = deviceUtils.deviceType;
    this.device_brand = deviceUtils.info.device.vendor;
    this.device_model = deviceUtils.info.device.model;
    this.os_lang = deviceUtils.info.device.lang_code;
    this.site_version = ARGS.VERSION_NUMBER;
    this.lang_id = state.language.id;
    this.competitors = userSelectionsManager.competitorsIds;
    this.total_teams = userSelectionsManager.competitorsIds?.length;
    this.total_leagues = userSelectionsManager.competitionsIds?.length;
    this.competitions = userSelectionsManager.competitionsIds;
    this.datekey = datetimeUtils.toDateObject().valueOf();
    this.os_lang = navigator.language;
    this.os_type = deviceUtils.info.os.name;
    this.os_version = deviceUtils.info.os.version;
    this.country_id = state.locale.userCountryId;
    this.timezone = new Date().getTimezoneOffset();
    this.show_wizard_ab_test = !state.wizardDisplayModel.blockDisplay;
    this.isLiveStreamingLightMode = state.appLiveStreamingDisplayModel.isLightMode;
    this.website_notifications = state.appNotificationDisplayModel.websiteNotifications;
    this.app_device_id = state.wizardDisplayModel.deviceId;
  }

  equals(model: AnalyticsUserDataEventModel): * {
    let equals = true;
    equals &= model.browser_type === this.browser_type;
    equals &= model.browser_version === this.browser_version;
    equals &= model.device_platform_type === this.device_platform_type;
    equals &= model.device_brand === this.device_brand;
    equals &= model.device_model === this.device_model;
    equals &= model.site_version === this.site_version;
    equals &= model.lang_id === this.lang_id;
    equals &= model.os_version === this.os_version;
    equals &= model.timezone === this.timezone;
    equals &= model.competitors.isEqual(model.competitors, this.competitors);
    equals &= model.competitors.isEqual(model.competitions, this.competitions);
    equals &= model.website_notifications === this.website_notifications;

    return equals;
  }

}
